import { rgb, StandardFonts } from 'pdf-lib';

export const breakWaiverPdf = async (pdfDoc, data, breakWaiverCheck) => {
  // Replace [name]
  const page = pdfDoc.getPages()[0];
  const { width, height } = page.getSize();

  page.drawRectangle({
    x: 76, // X position of the background
    y: height - 225, // Y position of the background
    width: width - 150, // Width of the background box (adjust as needed)
    height: 110, // Height of the background box (adjust as needed)
    color: rgb(1, 1, 1), // White color
  });
  const breakWaiver = `${data.DSP_TRADENAME} is committed to providing employees with uninterrupted, duty-free meal and rest breaks in accordance with state law. However, we understand that not all employees want to take an unpaid meal break, and would rather remain on the dock and work through the shift.\n \nWhere permitted by state law, you may elect to waive your meal breaks by using this for. This is a personal choice. ${data.DSP_TRADENAME} does not have a preference one way or another. You may revoke this waiver at any time simply by submitting a new form. You can request a new form from your manager.
`;
  page.drawText(breakWaiver, {
    x: 76, // X position of the placeholder
    y: height - 130, // Y position of the placeholder
    size: 11, // Text size
    color: rgb(0, 0, 0),
    lineHeight: 15,
    maxWidth: width / 1.2,
  });
  page.drawRectangle({
    x: 76, // X position of the background
    y: height - 400, // Y position of the background
    width: 150, // Width of the background box (adjust as needed)
    height: 35, // Height of the background box (adjust as needed)
    color: rgb(1, 1, 1), // White color
  });

  page.drawText(data.SUFFIX + data.NAME, {
    x: 78, // X position of the placeholder
    y: height - 395, // Y position of the placeholder
    size: 11, // Text size
    color: rgb(0, 0, 0),
    lineHeight: 15,
  });

  //////
  page.drawRectangle({
    x: 330, // X position of the background
    y: height - 400, // Y position of the background
    width: 100, // Width of the background box (adjust as needed)
    height: 35, // Height of the background box (adjust as needed)
    color: rgb(1, 1, 1), // White color
  });
  page.drawText(data.DATE, {
    x: 330, // X position of the placeholder
    y: height - 395, // Y position of the placeholder
    size: 11, // Text size
    color: rgb(0, 0, 0),
    lineHeight: 15,
  });
  /////
  page.drawRectangle({
    x: 76, // X position of the background
    y: height - 454, // Y position of the background
    width: 200, // Width of the background box (adjust as needed)
    height: 35, // Height of the background box (adjust as needed)
    color: rgb(1, 1, 1), // White color
  });
  const zapfDingbatsFont = await pdfDoc.embedFont(StandardFonts.ZapfDingbats);
  page.drawRectangle({
    x: 85, // X position of the background
    y: 500, // Y position of the background
    width: 10, // Width of the background box (adjust as needed)
    height: 10, // Height of the background box (adjust as needed)
    color: rgb(1, 1, 1), // White color
  });
  if (breakWaiverCheck == 3) {
    page.drawText(`✔`, {
      x: 88, // X position of the placeholder
      y: 500, // Y position of the placeholder
      size: 10, // Text size
      color: rgb(0, 0, 0), // Black color
      font: zapfDingbatsFont, // Pass the font correctly
    });
  }
  if (breakWaiverCheck == 4) {
    page.drawText(`✔`, {
      x: 88, // X position of the placeholder
      y: 445, // Y position of the placeholder
      size: 10, // Text size
      color: rgb(0, 0, 0), // Black color
      font: zapfDingbatsFont, // Pass the font correctly
    });
  }
  if (data.SIGNATURE) {
    data.SIGNATURE.forEach((pathString) => {
      page.drawSvgPath(pathString, {
        x: 72,
        y: height - 400,
        // color,
        // borderColor: color,
        borderWidth: 5,
        scale: 0.3,
      });
    });
  }
};
